import React from "react";
import { Box, Grid, Typography, Link, IconButton, Container } from "@mui/material";
import { Facebook, Instagram, Pinterest, Twitter, YouTube, Email, Phone, LocationOn } from "@mui/icons-material";

const gold = "#C29D59";
const darkBg = "#111";
const lightText = "rgba(255,255,255,0.8)";

const Footer = () => {
  return (
    <Container
        maxWidth={false}
        sx={{
          maxWidth: "1450px !important",
          mx: "auto",
          px: { xs: 2, md: 4 },
          pt:12
        }}
      >
 <Box sx={{ backgroundColor: darkBg, color: "#fff", py: 6,  }}>
      <Grid container spacing={11}>
        {/* 1️⃣ Logo & Social */}
        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ display: "flex", alignItems: "end",justifyContent:"start",mb:2 }}>
                   <img
                     src="/images/interior-aee.png"
                     alt="logo"
                     style={{ height: 42, marginRight: 8 }}
                   />
                   <Typography
                     variant="h6"
                     sx={{ fontWeight: "bold", color: "#fff", letterSpacing: 1,mt:0}}
                   >
                     INDESIG
                   </Typography>
                 </Box>
          <Typography variant="body2" sx={{ color: lightText, mb: 2 }}>
            At InteriorVista, we believe that every space should <br />
            tell a story. Our team of creative designers brings luxury, <br /> comfort, and innovation to your home or office.
          </Typography>
          <Box>
            {[Facebook, Instagram, Pinterest, Twitter, YouTube].map((Icon, i) => (
              <IconButton key={i} sx={{ color: "#fff", mr: 1, "&:hover": { color: gold } }}>
                <Icon fontSize="small" />
              </IconButton>
            ))}
          </Box>
        </Grid>

        {/* 2️⃣ Quick Links */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: gold }}>
            Quick Links
          </Typography>
          {["Home", "About", "Projects", "Services", "Blog"].map((item, i) => (
            <Link
              key={i}
              href="#"
              underline="none"
              sx={{
                display: "block",
                color: lightText,
                mb: 1,
                "&:hover": { color: gold },
              }}
            >
              {item}
            </Link>
          ))}
        </Grid>

        {/* 3️⃣ Services */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: gold }}>
            Our Services
          </Typography>
          {[
            "Residential Interiors",
            "Commercial Spaces",
            "Modular Kitchens",
            "Luxury Decor",
            "Renovation & Remodeling",
            
          ].map((item, i) => (
            <Link
              key={i}
              href="#"
              underline="none"
              sx={{
                display: "block",
                color: lightText,
                mb: 1,
                "&:hover": { color: gold },
              }}
            >
              {item}
            </Link>
          ))}
        </Grid>

        {/* 4️⃣ Useful Links */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: gold }}>
            Useful Links
          </Typography>
          {["FAQs", "Privacy Policy", "Terms & Conditions", "Support"].map((item, i) => (
            <Link
              key={i}
              href="#"
              underline="none"
              sx={{
                display: "block",
                color: lightText,
                mb: 1,
                "&:hover": { color: gold },
              }}
            >
              {item}
            </Link>
          ))}
        </Grid>

        {/* 5️⃣ Contact */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: gold }}>
            Contact Us
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Email sx={{ fontSize: 20, color: gold, mr: 1 }} />
            <Typography variant="body2" sx={{ color: lightText }}>
              info@interiorvista.com
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Phone sx={{ fontSize: 20, color: gold, mr: 1 }} />
            <Typography variant="body2" sx={{ color: lightText }}>
              +91 98765 43210
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <LocationOn sx={{ fontSize: 20, color: gold, mr: 1 }} />
            <Typography variant="body2" sx={{ color: lightText }}>
              23, Green Avenue, Indiranagar,
              <br /> Bengaluru, India
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Bottom Line */}
      <Box
        sx={{
          borderTop: "1px solid rgba(255,255,255,0.1)",
          mt: 5,
          pt: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="body2" sx={{ color: lightText }}>
          © {new Date().getFullYear()} InteriorVista. All rights reserved.
        </Typography>
      </Box>
    </Box>
      </Container>
   
  );
};

export default Footer;
